import React, { useState } from 'react'
import { Flex, Button } from 'rebass'
import Modal from 'components/Modal'
import Checkbox from 'components/Checkbox'
import Message from 'components/Message'
import {
  hasCvsProvider,
  hasD2dProvider,
  hasSyProvider,
} from 'models/checkoutProduct'

export default ({ value, open, action }) => {
  const [state, setState] = useState()

  const isSwitchable = (type) => {
    const cartItems = value[`${value.shippingType}CartItems`]
    const cartItem = cartItems[value.shippingIdx]
    if (!cartItem) return false

    const { shippingProviders } = cartItem.extra || {}

    switch (type) {
      case 'cvs':
        return hasCvsProvider(shippingProviders)
      case 'd2d':
        return hasD2dProvider(shippingProviders)
      case 'sy':
        return hasSyProvider(shippingProviders)
      default:
        return false
    }
  }

  return (
    <Modal
      title="checkout.btn.editShipping"
      open={open}
      onClose={action.handleClose}
      width={300}
      contentProps={{ bg: 'grey.0' }}
      as="form"
      onSubmit={(event) => {
        event.preventDefault()

        if (state) action.handleSubmit(value.shippingType, state)
        action.handleClose()
        setState(false)
      }}
    >
      <Flex alignItems="flex-start" flexDirection="column">
        {value.shippingType !== 'd2d' && isSwitchable('d2d') && (
          <Checkbox
            mr={2}
            label="checkout.tab.d2d"
            checked={state === 'd2d'}
            onChange={() => {
              setState('d2d')
            }}
          />
        )}
        {value.shippingType !== 'sy' && isSwitchable('sy') && (
          <Checkbox
            mr={2}
            label="checkout.tab.sy"
            checked={state === 'sy'}
            onChange={() => {
              setState('sy')
            }}
          />
        )}
        {value.shippingType !== 'cvs' && isSwitchable('cvs') && (
          <Checkbox
            mr={2}
            label="checkout.tab.cvs"
            checked={state === 'cvs'}
            onChange={() => {
              setState('cvs')
            }}
          />
        )}
      </Flex>
      <Flex justifyContent="flex-end" alignItems="center" mt={3}>
        <Button
          type="button"
          variant="secondary"
          mr={2}
          onClick={action.handleClose}
        >
          <Message id="btn.close" />
        </Button>
        <Button type="submit" variant="accent">
          <Message id="btn.confirm" />
        </Button>
      </Flex>
    </Modal>
  )
}
